import { useMutation } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import toastr from 'react-hot-toast';
import {
  generateAppendQueryParam,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import type { SingleBoardNodesResponse } from 'types/BoardNode';

const getBoardNodeByID = (boardNodeID: string | undefined) => {
  const queryArray = [generateAppendQueryParam('includeData', true)];
  const url = generateURL(
    SPARK_RESOURCE_TYPES.BOARD_NODES,
    queryArray,
    boardNodeID
  );
  return fetchWrapper<SingleBoardNodesResponse>({
    url,
    method: 'GET',
  });
};

export const useBoardNodeByID = () => {
  // this hook uses mutation hook for board events
  // see useReactFlowHelpers hook handleBoardEvents.
  return useMutation(
    'getBoardNodeByID',
    getBoardNodeByID,

    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`Failed get board Node: ${error.message}`);
        }
      },

      ...CACHE_AND_STALE_TIME,
    }
  );
};
